import React, { useState } from "react";
import api from "../api/api";

export default function FeedbackForm() {
  const [form, setForm] = useState({
    name: "",
    suggestion: "",
  });

  const [status, setStatus] = useState(null);

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await api.post("/feedback", form);

      setStatus({ type: "success", msg: res.data.suggestion });

      setForm({ name: "", suggestion: "" });
    } catch (error) {
      setStatus({
        type: "error",
        msg: error.response?.data?.error || "Error al enviar sugerencia",
      });
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      style={{
        background: "#FFFFFF",
        padding: "24px",
        borderRadius: "12px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
        maxWidth: "500px",
        width: "80%",
        display: "flex",
        flexDirection: "column",
        gap: "14px",
        margin: "0 auto",
      }}
    >
      <h3
        style={{
          color: "#00796B",
          marginBottom: "4px",
          fontWeight: "600",
          textAlign: "center",
        }}
      >
        Dejanos tu sugerencia o comentario
      </h3>

        <input
        type="text"
        name="name"
        placeholder="Tu nombre (opcional)"
        value={form.name}
        onChange={handleChange}
        style={{
          padding: "10px 12px",
          borderRadius: "8px",
          border: "1px solid #C5E1A5",
          outline: "none",
          fontSize: "15px",
          color: "#333333",
        }}
      />

      <textarea
        name="suggestion"
        rows="4"
        placeholder="Escribí tu sugerencia o comentario..."
        required
        value={form.suggestion}
        onChange={handleChange}
        style={{
          padding: "12px",
          borderRadius: "8px",
          border: "1px solid #C5E1A5",
          outline: "none",
          resize: "none",
          fontSize: "15px",
          color: "#333333",
        }}
      ></textarea>

      <button
        type="submit"
        style={{
          background: "#00796B",
          color: "#FFFFFF",
          padding: "12px",
          fontSize: "16px",
          border: "none",
          borderRadius: "8px",
          cursor: "pointer",
          transition: "0.2s",
        }}
        onMouseOver={(e) => (e.target.style.background = "#005F54")}
        onMouseOut={(e) => (e.target.style.background = "#00796B")}
      >
        Enviar sugerencia
      </button>

      {status && (
        <p
          style={{
            marginTop: "5px",
            color: status.type === "success" ? "#00796B" : "red",
            fontWeight: "bold",
            textAlign: "center",
          }}
        >
          {status.msg}
        </p>
      )}
    </form>
  );
}
